/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { CopyIcon16Light } from './CopyIcon16Light';
import { CopyIcon16Regular } from './CopyIcon16Regular';
import { CopyIcon16Solid } from './CopyIcon16Solid';
import { CopyIcon20Light } from './CopyIcon20Light';
import { CopyIcon20Regular } from './CopyIcon20Regular';
import { CopyIcon20Solid } from './CopyIcon20Solid';
import { CopyIcon24Regular } from './CopyIcon24Regular';
import { CopyIcon24Solid } from './CopyIcon24Solid';
import { CopyIcon32Regular } from './CopyIcon32Regular';
import { CopyIcon64Regular } from './CopyIcon64Regular';
var sizes = {
    16: {
        light: CopyIcon16Light,
        regular: CopyIcon16Regular,
        solid: CopyIcon16Solid,
    },
    20: {
        light: CopyIcon20Light,
        regular: CopyIcon20Regular,
        solid: CopyIcon20Solid,
    },
    24: {
        regular: CopyIcon24Regular,
        solid: CopyIcon24Solid,
    },
    32: {
        regular: CopyIcon32Regular,
    },
    64: {
        regular: CopyIcon64Regular,
    },
};
export var CopyIcon = forwardRef('CopyIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
